import * as React from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
} from "@mui/material";
import imgurl from "./assests/images/imgurl";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import leftArrow from "./assests/images/newimages/icons/backIcon.svg";
import rightArrow from "./assests/images/newimages/icons/rightIcon.svg";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router";
import { useState } from "react";
import { InputAdornment, IconButton } from "@mui/material";
import { CookieSharp, Visibility, VisibilityOff } from "@mui/icons-material";
import AlertComp from "./Alert";
import axios from "axios";
import {
  customerLogin,
  customerRegister,
  updateShopifyDetails,
} from "./api/api";
import { Input, FormControl } from "@mui/material";
import { Dialog, DialogTitle } from "@mui/material";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

export default function CompleteProfile() {
  const [activeStep, setActiveStep] = useState(0);
  let checkUserData = JSON.parse(sessionStorage.getItem("checkUser"));
  const [skipped, setSkipped] = useState(new Set());
  const navigate = useNavigate();
  const isStepSkipped = (step) => skipped.has(step);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  // const handleClose = (reason) => {
  //   if (reason === 'backdropClick') {
  //     return;
  //   }
  //   setOpen(false);
  // };

  const handleListItemClick = (value) => {
    setOpen(false);
    console.log("Selected value:", value);
  };
  // <!-----------------------------!>
  // select field state
  const [birth, setBirth] = useState("10");
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userId, setUserId] = useState("");
  // select gender state
  const [gender, setGender] = useState("10");
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("Test");

  const [showPassword, setShowPassword] = useState(false);
  const [userDocumentFile, setUserDocumentFile] = useState({
    nationalIdCard: null,
    document: null,
    documentNo: null,
    issuingCountryDocument: null,
  });

  console.log(userDocumentFile, "::>>userDocumentFile");
  const handleFileChange = (e, fieldName) => {
    setUserDocumentFile((prevFiles) => ({
      ...prevFiles,
      [fieldName]: e.target.value,
    }));
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleCustomerRegister = async () => {
    console.log(firstname, lastname, email, password, ">>all details");
    // console.log(checkUserData?.shopify_user_exist, "::>>TESTUSER");
    if (checkUserData?.shopify_user_exist) {
      setalertopen(true);
      setalertmsg("Email is already registered, Please login.");
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    }
    if (!firstname || !lastname || !email || !password) {
      setalertopen(true);
      setalertmsg("Please enter all the details.");
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    }
    let reqBody = {
      email: email,
      password: password,
      firstName: firstname,
      lastName: lastname,
    };
    // setLoading(true);
    try {
      const response = await axios.post(customerRegister, reqBody);
      console.log(response, "::>>response>>");
      //   setLoading(false);
      if (response.status == 200) {
        handleLoginUser();
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        const extractedUserId = response.data.userId.split("/").pop();
        console.log(extractedUserId, "::>>extractedUserId");
        setUserId(extractedUserId);
        handleSubmitUserId(extractedUserId, response.data.email);
        localStorage.setItem("fname", firstname);
        localStorage.setItem("lname", lastname);
        localStorage.setItem("userId", extractedUserId);
        // navigate("/resultnew");
      }
    } catch (error) {
      console.log(error, "Error");
    }
  };

  const handleLoginUser = async () => {
    let reqBody = {
      email: email,
      password: password,
    };
    // setLoading(true);
    try {
      const response = await axios.post(customerLogin, reqBody);
      console.log(response, "::>>response>>");
      //   setLoading(false);
      if (response.status == 200) {
        console.log(response.data.accessToken);
        localStorage.setItem("userToken", response.data.accessToken);
      }
    } catch (error) {
      console.log(error, "Error");
    }
  };

  async function uploadDocument() {
    if (!userDocumentFile.nationalIdCard || !userDocumentFile.documentNo) {
      setalertopen(true);
      setalertmsg("Please submit all the details.");
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    }
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("user_id"));
    formData.append(
      "document_type",
      userDocumentFile.nationalIdCard ? userDocumentFile.nationalIdCard : ""
    );
    formData.append("document_number", userDocumentFile.documentNo);
    formData.append(
      "document_file",
      userDocumentFile.document ? userDocumentFile.document : ""
    );
    formData.append(
      "document_issue_country",
      userDocumentFile.issuingCountryDocument
        ? userDocumentFile.issuingCountryDocument
        : ""
    );
    // navigate("/productdetls");

    try {
      const response = await axios.post(
        "https://aloxa.ai/flaskservice/upload_document",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status == 200) {
        handleClickOpen();
      }
      console.log("File uploaded successfully:", response.data);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  }

  const handleSubmitUserId = async (id, email) => {
    let reqBody = {
      phone_number: localStorage.getItem("phno"),
      shopify_customer_id: parseInt(id),
      email: email,
    };
    // setLoading(true);
    try {
      const response = await axios.post(updateShopifyDetails, reqBody);
      if (response.status == 200) {
        console.log(response, "::>>handleSubmitUserId>>");
      }
    } catch (err) {
      console.log(err, "::>>ERR-->handleSubmitUserId");
    }
  };

  // <!-----------------------------!>
  console.log(activeStep, "::>>activeStep");
  const handleNext = () => {
    let newSkipped = skipped;
    if (activeStep == 0) {
      handleCheckEmail();
      // handleCustomerRegister();
      return;
    }
    if (activeStep == 1) {
      uploadDocument();
    }
    // if (isStepSkipped(activeStep)) {
    //   newSkipped = new Set(newSkipped.values());
    //   newSkipped.delete(activeStep);
    // }
    // setActiveStep((prevActiveStep) => prevActiveStep + 1);
    // setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    // Only the second step ("Create an ad group") is optional.
    if (activeStep !== 1) {
      throw new Error("You can't skip a step that isn't optional.");
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  function AddDocument() {
    document.getElementById("input_file").click();
    document
      .getElementById("input_file")
      .addEventListener("change", function () {
        console.log(this.files[0]);
        setUserDocumentFile((prevFiles) => ({
          ...prevFiles,
          ["document"]: this.files[0],
        }));
      });
  }

  const handleBuyNow = () => {
    navigate("/productdetails");
    // let url = "https://shop.alopexia.com/products/alopexia-hair-restoration-medicine";
    // window.location.href = url;
  };

  const handleCheckEmail = async () => {
    if (!firstname || !lastname || !email || !password) {
      setalertopen(true);
      setalertmsg("Please enter all the details.");
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    }
    const data = {
      phone_number: localStorage.getItem("phno"),
      email: email,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        "https://aloxa.ai/flaskservice/check_user_email",
        data,
        config
      );
      if (response.status == 200) {
        if (response?.data?.status == true) {
          handleCustomerRegister();
        } else {
          setalertopen(true);
          setalertmsg(response?.data?.message);
          setTimeout(() => {
            setalertopen(false);
          }, 2000);
          return;
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className="photo-container main-section-container healthAssessmentReportSection completeProfileSection">
      <Dialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          }
        }}
        open={open}
        className="myCustomDialog"
        disableBackdropClick
      >
        <DialogTitle>You have registered successfully!</DialogTitle>
        <div className="dialogButtonWrapper">
          <button className="buyNowbtn" onClick={handleBuyNow}>
            Explore More
          </button>
        </div>
      </Dialog>
      <div className="">
        <div
          className="d-flex justify-content-start align-items-center gap-10px bgArrowDiv"
          style={{ position: "relative" }}
        >
          <span className="backButtonDiv mt-0px" onClick={() => navigate("/HealthAssessment")}>
            <ArrowBackOutlinedIcon
              className="arrowBackBtn"
            ></ArrowBackOutlinedIcon>
          </span>
          <div className="pageTitle">
            <h2 className="registerShortReportTitle">Complete your Profile</h2>
          </div>
        </div>
      </div>
      <Box sx={{ width: "100%" }} className="MainStepperSection mt-20px">
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          connector={<StepConnector />}
        >
          {/* Step 1 */}
          <Step completed={activeStep > 0 && !isStepSkipped(0)}>
            <StepLabel>
              <Typography variant="body2" align="center" sx={{ mt: 1 }}>
                Step 1
              </Typography>
            </StepLabel>
          </Step>
          {/* Step 2 */}
          <Step completed={activeStep > 1 && !isStepSkipped(1)}>
            <StepLabel>
              <Typography variant="body2" align="center" sx={{ mt: 1 }}>
                Step 2
              </Typography>
            </StepLabel>
          </Step>
        </Stepper>

        {activeStep === 2 ? (
          <Box textAlign="center" mt={3} className="stepper">
            <Typography className="color-white">
              All steps completed - you're finished
            </Typography>

            <Button
              color="inherit"
              onClick={handleReset}
              sx={{ mt: 2 }}
              className="BorderPreviewButton"
            >
              <div className="d-flex align-items-center gap-10px">
                <span> Reset </span>
              </div>
            </Button>
          </Box>
        ) : (
          <Grid container spacing={2} mt={3} className="mt-0px">
            <Grid item xs={12} className="pt-0px pl-0px">
              <div>
                {activeStep === 0 && (
                  <>
                    <div className="CommBgMainCard">
                      <Card className="mainCardInput mt-40px">
                        <CardContent className="w-100 CardContentInput">
                          <Grid container spacing={2} className="">
                            <Grid item xs={12}>
                              <Typography
                                variant="h5"
                                className="assessmentQuestion pl-0px"
                              >
                                Personal Information
                              </Typography>
                            </Grid>

                            <Grid item xs={12}>
                              <TextField
                                id="outlined-basic"
                                label="First Name"
                                variant="outlined"
                                placeholder="First Name"
                                className="mainInputField"
                                onChange={(e) => setfirstname(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                id="outlined-basic"
                                label="Last Name"
                                variant="outlined"
                                placeholder="Last Name"
                                className="mainInputField"
                                onChange={(e) => setlastname(e.target.value)}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <TextField
                                id="outlined-basic"
                                type="email"
                                label="Email Id"
                                variant="outlined"
                                placeholder="Email Id"
                                className="mainInputField"
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <TextField
                                id="outlined-basic"
                                //   type="password"
                                type={showPassword ? "text" : "password"}
                                label="Password"
                                variant="outlined"
                                placeholder="Password"
                                className="mainInputField"
                                onChange={(e) => setPassword(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                      >
                                        {showPassword ? (
                                          <VisibilityOff />
                                        ) : (
                                          <Visibility />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} className="">
                              <p className="d-flex justify-content-start align-items-start regretPara">
                                <InfoIcon></InfoIcon>
                                We need this information to generate
                                prescriptions and delivery of approved
                                medications in the European Union.
                              </p>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </div>
                  </>
                )}
                {activeStep === 1 && (
                  <>
                    <div className="CommBgMainCard">
                      <Card className="mainCardInput mt-40px">
                        <CardContent className="w-100 CardContentInput">
                          <Grid container spacing={2} className="">
                            {/* <Grid item xs={12}>
                              <Typography
                                variant="h5"
                                className="assessmentQuestion"
                              >
                                Document Information
                              </Typography>
                            </Grid>

                            <Grid item xs={12}>
                              <FormControl fullWidth variant="outlined">
                                <Typography variant="body1">
                                  Upload National ID Card
                                </Typography>
                                <Input
                                  type="file"
                                  inputProps={{ accept: "image/*,.pdf" }} // Adjust file types as needed
                                  className="mainInputField"
                                  onChange={(e) =>
                                    handleFileChange(e, "nationalIdCard")
                                  }
                                />
                              </FormControl>
                            </Grid> */}

                            {/* Document Upload */}
                            {/* <Grid item xs={12}>
                              <FormControl fullWidth variant="outlined">
                                <Typography variant="body1">
                                  Upload Document
                                </Typography>
                                <Input
                                  type="file"
                                  inputProps={{ accept: "image/*,.pdf" }} // Adjust file types as needed
                                  className="mainInputField"
                                  onChange={(e) =>
                                    handleFileChange(e, "document")
                                  }
                                />
                              </FormControl>
                            </Grid> */}

                            {/* Issuing Country Document Upload */}
                            {/* <Grid item xs={12}>
                              <FormControl fullWidth variant="outlined">
                                <Typography variant="body1">
                                  Upload Issuing Country Document
                                </Typography>
                                <Input
                                  type="file"
                                  inputProps={{ accept: "image/*,.pdf" }} // Adjust file types as needed
                                  className="mainInputField"
                                  onChange={(e) =>
                                    handleFileChange(
                                      e,
                                      "issuingCountryDocument"
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid> */}

                            <Grid item xs={12} className="">
                              {/* <TextField
                                id="outlined-basic"
                                label=""
                                variant="outlined"
                                placeholder="National ID Card"
                                className="mainInputField"
                                onChange={(e) =>
                                  handleFileChange(e, "nationalIdCard")
                                }
                              /> */}
                              <InputLabel
                                id="demo-simple-select-label"
                                placeholder="National ID Card"
                              >
                                National ID Document
                              </InputLabel>
                              {/* <FormControl fullWidth className="docdropdown">
                                <Select
                                  labelId="demo-simple-select-label"
                                  className="dropdowndocument"
                                  id="demo-simple-select"
                                  placeholder="National ID Card"
                                  displayEmpty
                                  label="Age"
                                  onChange={(e) =>
                                    handleFileChange(e, "nationalIdCard")
                                  }
                                >
                                  <MenuItem value={"Driving Licence"}>Driving Licence</MenuItem>
                                  <MenuItem value={"Passport"}>Passport</MenuItem>
                                </Select>
                              </FormControl> */}
                            </Grid>
                            <Grid item xs={12} className="">
                              <TextField
                                id="outlined-basic"
                                label=""
                                variant="outlined"
                                placeholder="Enter Your Document Number"
                                className="mainInputField"
                                onChange={(e) =>
                                  handleFileChange(e, "documentNo")
                                }
                              />
                            </Grid>
                            {/* <Grid item xs={12} className=""> */}
                            {/* <TextField
                                id="outlined-basic"
                                label=""
                                variant="outlined"
                                placeholder="Issuing Country"
                                className="mainInputField"
                                onChange={(e) =>
                                  handleFileChange(e, "issuingCountryDocument")
                                }
                              /> */}
                            {/* <FormControl fullWidth className="countrydropdown">
                                <InputLabel id="demo-simple-select-label" placeholder="Issuing Country">Issuing Country</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  className="dropdowndocument"
                                  id="demo-simple-select"
                                  label="Age"
                                  onChange={(e) =>
                                    handleFileChange(e, "issuingCountryDocument")
                                  }
                                >
                                  <MenuItem value={"Spain"}>Spain</MenuItem>
                                  <MenuItem value={"France"}>France</MenuItem>
                                  <MenuItem value={"Italy"}>Italy</MenuItem>
                                  <MenuItem value={"Switzerland"}>Switzerland</MenuItem>
                                  <MenuItem value={"India"}>India</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid> */}
                            <Grid item xs={12}>
                              <Button
                                variant="contained"
                                className=" DocUpldBtn mt-20px"
                                onClick={() => AddDocument()}
                              >
                                Add Document
                              </Button>
                              <input
                                type="file"
                                name=""
                                id="input_file"
                                accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                                hidden
                              />
                              <Grid item xs={1} className="pl-0px filenamediv">
                                {console.log(
                                  userDocumentFile.document != null,
                                  userDocumentFile.document
                                )}{" "}
                                {userDocumentFile.document != null && (
                                  <CheckCircleOutlineIcon className="checkIcon"></CheckCircleOutlineIcon>
                                )}
                                {userDocumentFile.document != null &&
                                  userDocumentFile.document.name}
                              </Grid>
                            </Grid>
                            <Grid item xs={12} className="">
                              <p className="d-flex justify-content-start align-items-start regretPara">
                                <InfoIcon></InfoIcon>
                                We need this information to generate
                                prescriptions and delivery of approved
                                medications in the European Union.
                              </p>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </div>
                  </>
                )}
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              display="flex"
              justifyContent="space-between"
              className="gap-10px"
            >
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                className="BorderPreviewButton"
              >
                <div className="d-flex align-items-center gap-10px">
                  <img src={rightArrow} className="prevLeftarrow"></img>
                  <span> Previous</span>
                </div>
              </Button>
              <Button onClick={handleNext} className="NextViewButton">
                {activeStep === 1 ? (
                  <div className="d-flex align-items-center gap-10px">
                    <span> Submit</span>
                    <img src={rightArrow} alt="Left Arrow" />
                  </div>
                ) : (
                  <div className="d-flex align-items-center gap-10px">
                    <span> Next </span>
                    <img
                      src={rightArrow}
                      alt="Left Arrow"
                      className="bgArrowWhite"
                    />
                  </div>
                )}
              </Button>
            </Grid>
            <div className="loginUserButtonWrapper">
              <p>Email already registered?</p>
              <Button
                onClick={() => navigate("/loginshopifyuser")}
                className="loginUserButton"
              >
                Login
              </Button>
            </div>
          </Grid>
        )}
      </Box>
      <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
    </div>
  );
}
